@if (loading()) {
  <div class="loading-state p-4">
    <span class="text-sm opacity-60">Loading allocations...</span>
  </div>
} @else if (error()) {
  <div class="error-state p-4">
    <span class="text-warn text-sm">{{ error() }}</span>
  </div>
} @else if (allocations().length === 0) {
  <div class="no-data p-4">
    <span class="text-sm opacity-60">No practitioner allocations found</span>
  </div>
} @else {
  <div class="allocation-header mb-2">
    <span class="text-sm font-semibold">Allocation Breakdown</span>
    @if (hasOverAllocations()) {
      <mat-icon color="warn" class="icon-sm ml-2">warning</mat-icon>
    }
  </div>
  <div class="table-container">
    <table mat-table class="allocation-table" [dataSource]="allocations()">
      <!-- Practitioner Column -->
      <ng-container matColumnDef="practitioner">
        <th *matHeaderCellDef mat-header-cell>Practitioner</th>
        <td *matCellDef="let row" mat-cell>{{ row.practitioner.name }}</td>
      </ng-container>

      <!-- Invoiced Column -->
      <ng-container matColumnDef="invoiced">
        <th *matHeaderCellDef mat-header-cell>
          <span class="flex items-center gap-1">
            Invoiced
            <mat-icon
              class="icon-xs text-gray-400"
              matTooltip="Total amount invoiced for this practitioner"
            >
              info
            </mat-icon>
          </span>
        </th>
        <td *matCellDef="let row" mat-cell>
          {{ row.invoicedAmount | currency }}
        </td>
      </ng-container>

      <!-- Discount Column -->
      <ng-container matColumnDef="discount">
        <th *matHeaderCellDef mat-header-cell>
          <span class="flex items-center gap-1">
            Discount
            <mat-icon
              class="icon-xs text-gray-400"
              matTooltip="Amount discounted from this practitioner"
            >
              info
            </mat-icon>
          </span>
        </th>
        <td *matCellDef="let row" mat-cell>
          {{ row.discountAmount | currency }}
        </td>
      </ng-container>

      <!-- Remaining Column -->
      <ng-container matColumnDef="remaining">
        <th *matHeaderCellDef mat-header-cell>
          <span class="flex items-center gap-1">
            Remaining
            <mat-icon
              class="icon-xs text-gray-400"
              matTooltip="Amount still available to allocate"
            >
              info
            </mat-icon>
          </span>
        </th>
        <td
          *matCellDef="let row"
          mat-cell
          [class.text-warn]="row.isOverAllocated"
        >
          {{ row.remainingAmount | currency }}
        </td>
      </ng-container>

      <!-- Allocated Column -->
      <ng-container matColumnDef="allocated">
        <th *matHeaderCellDef mat-header-cell>
          <span class="flex items-center gap-1">
            Allocated
            <mat-icon
              class="icon-xs text-gray-400"
              matTooltip="Amount already allocated from transactions"
            >
              info
            </mat-icon>
          </span>
        </th>
        <td *matCellDef="let row" mat-cell>
          {{ row.allocatedAmount | currency }}
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr
        *matRowDef="let row; columns: displayedColumns"
        mat-row
        [class.row-over-allocated]="row.isOverAllocated"
      ></tr>
    </table>
  </div>
}
